import React, { useRef, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2';
import axios from 'axios';
import {
  AWS_BUCKET_MMS,
  S3_GET_PRESIGNED_URLS
} from '../../../utils/constants';

const ImageUploader = ({ setImageData }) => {
  const [preview, setPreview] = useState('');
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const uploadToS3 = async (file, originalURL) => {
    setUploading(true);

    const fileType = file.type;
    const fileName = `${uuidv4()}.${file.name.split('.').pop()}`;

    try {
      // 1. Obtener la URL prefirmada desde tu API Gateway
      const presignedResponse = await fetch(S3_GET_PRESIGNED_URLS, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          bucketName: AWS_BUCKET_MMS,
          files: [{ fileName, fileType }]
        })
      });

      if (!presignedResponse.ok) {
        throw new Error('Failed to get presigned URL');
      }

      const { urls } = await presignedResponse.json();
      const presignedUrl = urls?.[0]?.url;

      if (!presignedUrl) {
        throw new Error('No presigned URL returned');
      }

      // 2. Subir el archivo directamente a S3
      const uploadResult = await fetch(presignedUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': fileType
        },
        body: file
      });

      if (!uploadResult.ok) {
        throw new Error('File upload to S3 failed');
      }

      // 3. Actualizar UI con URL subida
      const uploadedFileUrl = `https://${AWS_BUCKET_MMS}.s3.amazonaws.com/${fileName}`;

      setPreview(uploadedFileUrl);
      setImageData({
        originalURL: originalURL || uploadedFileUrl,
        text: file.name || fileName,
        url: uploadedFileUrl
      });

      console.log(`File uploaded successfully: ${uploadedFileUrl}`);
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'Failed to upload image', 'error');
    }

    setUploading(false);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
      uploadToS3(file, null);
    }
  };

  const handleUrlChange = async (event) => {
    const imageUrl = event.target.value;
    setPreview(imageUrl);

    try {
      setUploading(true);
      const response = await axios.get(imageUrl, { responseType: 'blob' });

      const file = new File([response.data], `${uuidv4()}.jpg`, {
        type: response.headers['content-type']
      });

      uploadToS3(file, imageUrl);
    } catch (error) {
      Swal.fire('Error', 'Failed to fetch the image from the URL', 'error');
    }
  };

  return (
    <div>
      {preview && (
        <div style={{ marginBottom: '1em', textAlign: 'center' }}>
          <img
            src={preview}
            alt="Preview"
            style={{
              maxWidth: '100%',
              maxHeight: '200px',
              borderRadius: '8px'
            }}
          />
        </div>
      )}

      <div
        style={{
          textAlign: 'center',
          padding: '1.5em',
          border: '2px dashed #ccc',
          borderRadius: '8px',
          cursor: 'pointer'
        }}
        onClick={() => fileInputRef.current.click()}>
        <p>Drag and drop images here or</p>
        <button
          style={{
            backgroundColor: '#3766a8',
            color: 'white',
            border: 'none',
            padding: '0.75em 1.5em',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}>
          Select images
        </button>
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />
      </div>

      <div style={{ marginTop: '1em' }}>
        <h5>Image URL</h5>
        <input
          type="text"
          className="form-control"
          onChange={handleUrlChange}
          placeholder="Enter image URL"
        />
      </div>

      {uploading && <p>Uploading...</p>}
    </div>
  );
};

export default ImageUploader;
